export const NO_EMAIL_LABEL = 'Patient has no email'
export const INVALID_EMAIL_TEXT = 'Enter a valid email address'
export const EMAIL_OR_NO_EMAIL_TEXT = 'Enter an email or tick "Patient has no email"'

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

/** Basic format check (the backend does the real validation, incl. placeholder rejection). */
export const isValidEmail = (value?: string | null): boolean => !!value && EMAIL_RE.test(value.trim())

/** Registration rule: an email or the "Patient has no email" box. null = OK. */
export function registrationEmailError(email: string | null | undefined, noEmail: boolean): string | null {
  if (noEmail) return null
  const value = (email ?? '').trim()
  if (!value) return EMAIL_OR_NO_EMAIL_TEXT
  return isValidEmail(value) ? null : INVALID_EMAIL_TEXT
}

/** True for a 422 whose errors include code `invalid_email`. */
export function isInvalidEmailError(error: unknown): boolean {
  const err = error as { response?: { data?: { errors?: { code?: string }[] } } } | undefined
  return !!err?.response?.data?.errors?.some(e => e?.code === 'invalid_email')
}

/** Patient attributes include the results-email fields (backend deployed). */
export const hasResultsEmailFields = (attrs?: object | null): boolean => !!attrs && 'no_email' in attrs
